import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import AddVideoTutotial from "./add";
import ListVideoTutotial from "./list";

const Main = ({ match }) => (
  <Switch>
    <Route path={`${match.url}/add`} component={AddVideoTutotial} />
    <Route path={`${match.url}/edit/:id`} component={AddVideoTutotial} />
    <Route path={`${match.url}/list`} component={ListVideoTutotial} />
    <Route exact path={`${match.url}/`}>
      <Redirect to={`${match.url}/list`} />
    </Route>
  </Switch>
);

export default Main;
